import { Box, Skeleton } from '@mui/material';
import { Line } from 'react-chartjs-2';

const SalesValues : React.FC<any> = ({ charts_sales, loading }) => {

    const data = {
        labels: charts_sales.labels,
        datasets: [
            {
                label : "",
                data: charts_sales.data,
                backgroundColor: 'rgb(0,145,214)',
                borderColor: 'rgb(0,145,214)',
            }
        ]
    };

    const options = {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
        },
        scales: {
          yAxis: {
            min: 0,
          },
        },
      };

    return (
        <Box sx={{p:2}}>
          { loading ?
                <Box>
                    <Skeleton height={70} variant="rectangular" />
                </Box>
                :
            <div id="chart">
                <Line options={options} data={data} height={350}  />
            </div>
          }
        </Box>
    )
}

export default SalesValues
